module.exports = __webpack_public_path__ + "img/仁恒@2x.c71b9230.png";